import React, { useState, useEffect } from 'react';
import Calendar from 'react-calendar';

import * as dayjs from 'dayjs';
import Modal from './modal';
import { useTranslation } from 'react-i18next';

export function DatePickerDialog({ close, onChange, value }) {
  const { t } = useTranslation();

  const [show, setShow] = useState(true);
  const [date, setDate] = useState(new Date());

  const closeWindow = () => {close ? close() : setShow(false)};

  useEffect(() => {
    if (typeof value?.getHours !== 'function' || value === date) {
      return;
    }
    
    setDate(value)
  }, [value])

  const changeDate = (value) => {
    setDate(value)
  }

  const save = () => {
    onChange(date);
    closeWindow();
  };

  const cancel = () => {
    closeWindow();
  };

  return(
    <Modal openModal={show} closeModal={closeWindow}>
      <div className="data-dialog">
        <div className="dialog-header flex1 flex-column">
          <div className="dialog-header-title">{t('dialog.select_data')}</div>
        </div>
        <DatePicker value={date} onChange={changeDate}/>
      </div>
      <div className="time-picker-element">
            <div className="select-buttons">
              <button className="button" onClick={cancel}>{t('buttons.common.cancel')}</button>
              <button className="button button-primary" onClick={save}>{t('buttons.common.save')}</button>
            </div>
          </div>
    </Modal>
  )
}

export function DatePicker({ onChange, value }) {
  const { i18n } = useTranslation();

  const [date, setDate] = useState(new Date());
  const [{ hour, minutes }, setTime] = useState({ hour: 17, minutes: 0 })

  useEffect(() => {
    if (typeof value?.getHours !== 'function' || isNaN(value.getHours())) {
      return;
    }
    
    if (value !== date) {
      setDate(value)
      setTime({ hour: value.getHours(), minutes: value.getMinutes()})
    }
  }, [value])

  const changeDate = (value) => {
    // setDate(val)
    const newDate = new Date(value);
    newDate.setHours(hour, minutes, 0);

    onChange(newDate)
  }


  const tileDisabled = ({ date }) => dayjs(date).isBefore(dayjs().startOf('day'));

  return (

        <div className="flex1 flex-between">
          <div className="calendar-section">
            <div className="date-display">{dayjs(date).format('dddd, D MMMM YYYY')}</div>
            <div className="calendar-editor-scene">
              <Calendar
                value={date}
                locale={i18n.language}
                onChange={date => changeDate(date)}
                formatDay={(_, date) => dayjs(date).format('D')}
                formatMonthYear={(_, date) => dayjs(date).format('MMM YYYY')}
                tileDisabled={tileDisabled}
              />
            </div>
          </div>
          
        </div>

  );
}

const customStyles = {
  control: provided => ({
    ...provided,
    backgroundColor: '#F7F7F7',
    boxShadow: 'none',
    border: 'none',
  }),
  singleValue: (provided, state) => ({
    ...provided,
    color: state.isFocused ? '#29304b' : '#7a7a7a',
  }),
  option: (provided, { isFocused, isSelected }) => ({
    ...provided,
    backgroundColor: isSelected ? '#29304b' : isFocused ? '#E0E0E0' : '#FFFFFF',
    color: isSelected ? '#FFFFFF' : '#7a7a7a',
  }),
  multiValue: styles => ({
    ...styles,
    backgroundColor: 'none',
  }),
};
